// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__tKzNz","row":"Node_row__1D8gs","label":"Node_label__TzPtu","footer":"Node_footer__ajHTB"};